import { newsletterSubscribeAction } from 'redux/actions/newsletterActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

const subscribeNewsletterReducer = generateRequestWithDataReducer(newsletterSubscribeAction);

export { subscribeNewsletterReducer };
